import { get } from 'svelte/store';
import { profile_data, user_data } from 'src/stores/account/user';
import { save_profile } from 'src/helpers/profile_helpers';
import { isSubUnit } from 'src/helpers/user_helpers';
import { getOwnedHomeCount } from 'src/helpers/houses/homes_helpers';

export const HOMES_WHATS_NEW_KEY = 'homesWhatsNew';

/** Update before release — used to re-show the intro after copy changes. */
export const HOMES_WHATS_NEW_RELEASE_TIMESTAMP = Math.floor(
	new Date('2026-06-01T00:00:00Z').getTime() / 1000,
);

const HOMES_WHATS_NEW_NEVER_SEEN = 0;

export function isHomesWhatsNewSeen(
	profileData: Record<string, unknown> | undefined = get(profile_data),
): boolean {
	const seenAt = profileData?.[HOMES_WHATS_NEW_KEY];
	return typeof seenAt === 'number' && seenAt >= HOMES_WHATS_NEW_RELEASE_TIMESTAMP;
}

export function shouldShowHomesWhatsNew(
	profileData: Record<string, unknown> | undefined = get(profile_data),
): boolean {
	if (isSubUnit()) return false;
	if (getOwnedHomeCount(get(user_data).available_units) > 1) return false;
	return !isHomesWhatsNewSeen(profileData);
}

export async function markHomesWhatsNewSeen(): Promise<boolean> {
	const res = await save_profile(HOMES_WHATS_NEW_KEY, HOMES_WHATS_NEW_RELEASE_TIMESTAMP);
	return res?.isok === true;
}
